import { industries_constants } from "../data-annotation/constants";

const Industries = () => {
  return (
    <section className="py-[54px] relative overflow-hidden bg-white">
      <div className="container  px-3">
        <div className="text-center mb-[28px] md:mb-16 ">
          <h2 className="text-[#222] text-[22px] md:text-[40px] font-medium">
            {industries_constants.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {industries_constants.services.map((service) => (
            <div
              key={service.id}
              className={`py-3 px-4 rounded-zl border-[0.5px] cursor-pointer transition-all duration-300 hover:shadow flex flex-col rounded-[12px] gap-3 hover:bg-[#EDF8FF] hover:border-primary_alt hover:text-[#222] bg-transparent  border-[#E5E5E5]  text-gray-900`}
            >
              <div
                className={`flex justify-center items-center h-12 w-12 rounded-[28px] border-[8px] border-[#E7ECFC] bg-primary_alt`}
              >
                <service.icon />
              </div>
              <div className="space-y-1">
                <h3 className="text-xl md:text-[24px] font-medium text-[#222]">
                  {service.title}
                </h3>
                <p className="text-[15px] text-[#222] w-full">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
